<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            md="9"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <p class="h5 mt-50 mr-75 ml-50">
              조회 타입
            </p>
            <b-form-radio-group
              v-model="query.isPrefixSum"
            >
              <b-form-radio :value="true">
                누적
              </b-form-radio>
              <b-form-radio :value="false">
                일별
              </b-form-radio>
            </b-form-radio-group>
            <!-- <p class="h5 mt-50 mr-75 ml-50">
              조회 기준
            </p>
            <b-form-radio-group
              v-model="query.searchType"
            >
              <b-form-radio :value="1">
                의원
              </b-form-radio>
              <b-form-radio :value="2">
                의사
              </b-form-radio>
            </b-form-radio-group> -->
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            md="8"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-input
              v-model="query.filterStr"
              placeholder="제목을 입력하세요"
              class="el-def"
              style="width: 350px"
            />
            <v-select
              v-model="query.status"
              :options="codes.surveyStatus"
              placeholder="설문상태(전체)"
              :reduce="option => option.code"
              class="el-def"
              style="width: 200px"
            />
            <b-form-datepicker
              v-model="query.startDate"
              class="el-def"
              placeholder="조회기간(Fr)"
              style="width: 240px"
            />
            <label class="ml-25 mr-50">~</label>
            <b-form-datepicker
              v-model="query.endDate"
              class="el-def"
              placeholder="조회기간(To)"
              style="width: 240px"
            />
            <b-form-input
              v-model="query.liveInfoId"
              class="el-def"
              placeholder="ID"
              style="width: 140px;"
            />
          </b-col>
          <b-col
            md="4"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-dark"
              class="btn-search ml-1"
              @click.prevent="downloadSurveySummaryResult()"
            >
              <feather-icon
                icon="DownloadIcon"
                class="mr-50"
              />
              <span>요약 결과 다운로드</span>
            </b-button>
            <b-button
              variant="outline-dark"
              class="btn-search ml-1"
              @click.prevent="downloadSurveyResult()"
            >
              <feather-icon
                icon="DownloadIcon"
                class="mr-50"
              />
              <span>설문 결과 다운로드</span>
            </b-button>
            <b-button
              variant="outline-dark"
              class="btn-search ml-1"
              @click.prevent="excelDownload()"
            >
              <feather-icon
                icon="DownloadIcon"
                class="mr-50"
              />
              <span>통계 엑셀 다운로드</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card>
      <div>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            해당 통계는 엑셀 다운로드만 제공됩니다.
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import axios from '@axios'
import vSelect from 'vue-select'
import { onMounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { saveAs } from "file-saver"

export default {
  components: {
    vSelect,
  },

  setup() {
    onMounted(() => {
      fetchCodes()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    // Set Codes
    const codes = ref({
      surveyStatus: [],
    })

    const fetchCodes = () => {
      axios.get('/fa/statistics/survey/codes')
        .then(rs => {
          const {
            surveyLiveStatus,
          } = rs.data
          const surveyStatus = surveyLiveStatus.filter(x => x.code > 1)
          codes.value.surveyStatus = surveyStatus
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }
    // Set Codes End.

    const query = ref({
      isPrefixSum: true,
      // searchType: 1,
      startDate: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      status: null,
      filterStr: null,
      liveInfoId: null,
    })

    // const searchType = ref(1)

    const excelDownload = () => {
      const frDate = dayjs(query.value.startDate)
      const toDate = dayjs(query.value.endDate)

      if (!query.value.liveInfoId?.trim()) {
        pushToast('warning', 'ID는 필수 검색조건입니다.')
        return
      }

      if (Math.abs(frDate.diff(toDate, 'day')) > 90) {
        pushToast('warning', '조회 기간은 최대 90일을 넘을 수 없습니다.')
        return
      }

      axios.get(`/fa/statistics/survey/excel`, {
        params: {
          isPrefixSum: query.value.isPrefixSum,
          // searchType: query.value.searchType,
          startDate: query.value.startDate,
          endDate: query.value.endDate,
          status: query.value.status,
          filterStr: query.value.filterStr,
          liveInfoId: query.value.liveInfoId,
        },
        responseType: 'blob',
      })
        .then(rs => {
          if (rs?.data?.size > 0) {
            const blob = new Blob([rs.data])
            saveAs(blob, `설문조사 통계(${query.value.isPrefixSum === true ? '누적' : '일별'}).xlsx`)
          }
        })
        .catch(() => {
          pushToast('danger', '데이터 조회 중 오류가 발생하였습니다.')
        })
    }

    const downloadSurveyResult = () => {
      const frDate = dayjs(query.value.startDate)
      const toDate = dayjs(query.value.endDate)

      if (!query.value.liveInfoId?.trim()) {
        pushToast('warning', 'ID는 필수 검색조건입니다.')
        return
      }

      if (Math.abs(frDate.diff(toDate, 'day')) > 90) {
        pushToast('warning', '조회 기간은 최대 90일을 넘을 수 없습니다.')
        return
      }

      axios.get(`/fa/statistics/survey/download/${query.value.liveInfoId}`, { responseType: 'blob' })
        .then(rs => {
          const blob = new Blob([rs.data])
          const fileName = `설문결과_${dayjs().format('YYYYMMDDHHmmss')}`

          saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(() => {
        })
    }

    // 요약 결과 다운로드 (설문 페이지별 시트 / 문항별 집계)
    const downloadSurveySummaryResult = () => {
      const frDate = dayjs(query.value.startDate)
      const toDate = dayjs(query.value.endDate)

      if (!query.value.liveInfoId?.trim()) {
        pushToast('warning', 'ID는 필수 검색조건입니다.')
        return
      }

      if (Math.abs(frDate.diff(toDate, 'day')) > 90) {
        pushToast('warning', '조회 기간은 최대 90일을 넘을 수 없습니다.')
        return
      }

      axios.get(`/fa/statistics/survey/summary-download/${query.value.liveInfoId}`, { responseType: 'blob' })
        .then(rs => {
          const blob = new Blob([rs.data])
          const fileName = `설문요약결과_${dayjs().format('YYYYMMDDHHmmss')}`

          saveAs(blob, `${fileName}.xlsx`)
        })
        .catch(() => {
          pushToast('danger', '데이터 조회 중 오류가 발생하였습니다.')
        })
    }

    return {
      codes,
      query,
      // searchType,
      excelDownload,
      downloadSurveyResult,
      downloadSurveySummaryResult,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
